import { BrowserRouter } from 'react-router-dom'
import { ThemeProvider } from 'styled-components'
import Routes from './routes'
import Provider from './provider/Provider'

const themeData = {
    colorPrimary: '#1A3549',
    colorSecoundary: '#F8F9FA',
    headerHeight: 90,
    footerHeight: 50,
    shadow: `rgba(0, 0, 0, 0.1) 0px 4px 6px -1px,
    rgba(0, 0, 0, 0.06) 0px 2px 4px -1px`
}

const App = () => {
    return (
        <Provider>
            <BrowserRouter>
                <ThemeProvider theme={themeData}>
                    <Routes />
                </ThemeProvider>
            </BrowserRouter>
        </Provider>
    )
}

export default App
